import React from 'react';
import { Result, VertButton } from '@vertem-core/vertice-ds';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title="Transferência bancária"
      subTitle=" Não foi possível acessar a página solicitada, por favor, verifique suas credenciais de acesso."
      extra={
        <VertButton
          type="default"
          onClick={() => navigate('/')}
          className="button-redirect-pix"
        >
          Voltar para Catálogo
        </VertButton>
      }
      style={{
        fontSize: '20px',
      }}
    />
  );
};

export default Unauthorized;
